import { Button, Flex, Heading, IconButton, Separator } from '@chakra-ui/react'
import { BsGrid, BsList } from 'react-icons/bs'
import Tooltip from '@/components/Tooltip'
import type { ViewMode } from '../types'

type HeaderProps = {
  view: ViewMode
  onViewChange: (view: ViewMode) => void
  onNewAgenda: () => void
}

const Header = ({ view, onViewChange, onNewAgenda }: HeaderProps) => (
  <Flex justify="space-between" align="center" gap={2}>
    <Heading>Agendas</Heading>
    <Flex align="center" gap={3}>
      <Flex display={{ base: 'none', md: 'flex' }}>
        <Tooltip content="Visualizar em lista" showArrow>
          <IconButton
            aria-label="Visualizar em lista"
            variant={view === 'list' ? 'solid' : 'ghost'}
            bg={view === 'list' ? undefined : 'white'}
            size="sm"
            onClick={() => onViewChange('list')}
          >
            <BsList />
          </IconButton>
        </Tooltip>
        <Tooltip content="Visualizar em grade" showArrow>
          <IconButton
            aria-label="Visualizar em grade"
            variant={view === 'grid' ? 'solid' : 'ghost'}
            bg={view === 'grid' ? undefined : 'white'}
            size="sm"
            onClick={() => onViewChange('grid')}
          >
            <BsGrid />
          </IconButton>
        </Tooltip>
      </Flex>
      <Separator orientation="vertical" height="6" display={{ base: 'none', md: 'block' }} />
      <Button size="sm" colorPalette="primary" onClick={onNewAgenda}>
        Nova agenda
      </Button>
    </Flex>
  </Flex>
)

export default Header
